import React from "react";
import Layout from "./Layout";
import { ValidationProps } from "../../types";

const ApplicationName: React.FC<ValidationProps> = ({ value, valid, validation, handleChange, shouldValidate }) => {
	return (
		<Layout
			value={value}
			valid={valid}
			validation={validation}
			handleChange={handleChange}
			shouldValidate={shouldValidate}
		/>
	);
};

export default ApplicationName;
